import {EmailVerificationRedeemApiInterface} from "../api/interface/email-verification-redeem";
import type {EmailVerificationRedeemResponse} from "../api/payload-types/email-verification";
import type {RevaThunkAction} from "./revaHooks";

/**
 * #19351: Redeems an e-mail-verification token together with username and password, proving the caller
 * controls both the login and the mailbox the link was sent to. Backs REVA's own `/verify-email` page for
 * links REVA triggered. No auth state is read or touched. Rejects with the raw `WebError` on 422/429/503
 * (see {@link EmailVerificationRedeemApiInterface}).
 */
export const redeemEmailVerificationThunk =
    (token: string, username: string, password: string): RevaThunkAction<Promise<EmailVerificationRedeemResponse>> =>
    async (_dispatch, _getState, {serviceApi}) => {
        return new EmailVerificationRedeemApiInterface({token, username, password}).execute(serviceApi);
    };
